import { VictoryContainer, VictoryLabel, VictoryPie, VictoryTooltip } from "victory";
import Box from "../Box";

type PieChartProps = {
  colors: string[];
  data: {
      key: string,
      y: number,
      label?: string,
    }[]
  height?: number;
  width?: number;
  radius?: number;
  innerRadius?: number;
  origin?: { x: number; y: number };
  cornerRadius?: number;
  labelX?: number;
  labelY?: number;
  showTooltip?: boolean;
};

const PieChart = ({ 
  colors, 
  data,
  height = 110,
  width = 110,
  radius = 50,
  innerRadius = 30,
  origin = { x: 50, y: 50 },
  labelX = 65,
  labelY = 65,
  showTooltip = false
}: PieChartProps) => {

  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      alignItems={"center"}
      justifyContent={"center"}
    >
      <VictoryContainer
        height={height}
        width={width}
        responsive={false}
        style={{
          touchAction: "auto",
          overflow: "visible",
        }}
      >
        <VictoryPie
          data-testid={"donut"}
          colorScale={colors}
          data={data}
          labels={showTooltip ? undefined : () => null}
          labelComponent={
            showTooltip ? (
              <VictoryTooltip
                style={{ fontFamily: "system-ui", fontSize: 12 }}
                flyoutStyle={{ fill: "white", stroke: "#d9d9d9", strokeWidth: 1 }}
                pointerLength={5}
                cornerRadius={4}
              />
            ) : undefined
          }
          radius={radius}
          innerRadius={innerRadius}
          standalone={false}
          origin={origin}
          cornerRadius={() => 0}
          events={
            showTooltip
              ? [
                  {
                    target: "data",
                    eventHandlers: {
                      onMouseOver: () => {
                        return [
                          {
                            target: "data",
                            mutation: (props) => ({ style: { ...props.style, fillOpacity: 0.7 } })
                          },
                          {
                            target: "labels",
                            mutation: () => ({ active: true })
                          }
                        ];
                      },
                      onMouseOut: () => {
                        return [
                          {
                            target: "data",
                            mutation: () => null
                          },
                          {
                            target: "labels",
                            mutation: () => ({ active: false })
                          }
                        ];
                      }
                    }
                  }
                ]
              : undefined
          }
        />
        <VictoryLabel
          textAnchor="middle"
          style={[
            {
              fontFamily: "system-ui",
              fontSize: 20,
              fontWeight: "bold",
            },
            {
              fontFamily: "system-ui",
              fontSize: 14,
              fontWeight: "bold",
            },
          ]}
          x={labelX}
          y={labelY}
          text={[""]}
          inline
        />
      </VictoryContainer>
    </Box>
  );
};

export default PieChart;
